import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import Chips from "../chips/Chips";
import { ExperienceEntry } from "../../data/experience";
import { fadeUpItem } from "../../animations/variants";
import "./WorkCard.css";

interface WorkCardProps {
  entry: ExperienceEntry;
}

function WorkCard({ entry }: WorkCardProps) {
  const { t } = useTranslation();
  const isCurrent = !entry.endYear;
  const dateRange = `${entry.startYear} — ${isCurrent ? t("experience.present") : entry.endYear}`;

  return (
    <motion.div className={`work-item ${isCurrent ? "active" : ""}`} variants={fadeUpItem}>
      <div className="work-marker" aria-hidden="true" />
      <div className="work-card">
        <div className="work-card-head">
          <div>
            <h3 className="work-title">
              {entry.title} <span className="work-company">— {entry.company}</span>
            </h3>
            <span className="work-date">{dateRange}</span>
          </div>
          <a
            href={entry.link}
            target="_blank"
            rel="noreferrer"
            className="work-link"
            aria-label={t("experience.visitAria", { company: entry.company })}
          >
            <ExternalLink size={16} />
          </a>
        </div>
        <p className="work-description">{t(`experience.${entry.id}.description`)}</p>
        <Chips chips={entry.chips} />
      </div>
    </motion.div>
  );
}

export default WorkCard;
